import React, {
    useMemo, useState
} from 'react';
import { useParams } from 'react-router-dom';

import { useSearchQueryPlayback } from 'bdvp-common/src/hooks/store';
import { useDictionary } from 'bdvp-common/src/hooks/config';
import { CONTENT_PREFERENCE_CRITERIA } from 'bdvp-advanced-search/src/utils/constants';

import InningsComponent from '../components/Innings';

import useGameData from '../hooks/useGameData';

const defaultInnings = [];

const Innings = ({
    skip,
}) => {

    const {
        loading: gameLoading,
        error: gameError,
        data: gameData,
    } = useGameData();
    const dictionary = useDictionary();

    const innings = gameData?.lineScore?.innings || defaultInnings;
    const inningOptions = useMemo(() => innings.map(({ num, ordinalNum }) => ({
        label: `${ordinalNum} ${dictionary.inning ?? 'Inning'}`,
        value: num,
    })), [
        innings,
        dictionary,
    ]);

    const [
        selectedInning,
        setSelectedInning,
    ] = useState();

    const currentInning = selectedInning || inningOptions[0];

    const { gamePk } = useParams();

    const searchQuery = `gamePk = ${gamePk} AND Inning = [${currentInning?.value}] Order By Timestamp ASC`;

    const skipSearchQuery = skip || gameLoading || !!gameError || innings.length === 0;

    const searchQueryOptions = {
        limit: 20,
        ssr: false,
        skip: skipSearchQuery,
        contentPreference: CONTENT_PREFERENCE_CRITERIA.mixed,
    };

    const {
        loading: searchQueryLoading,
        loadingMore,
        data: searchQueryData,
        error: searchQueryError,
        fetchMoreData,
    } = useSearchQueryPlayback(searchQuery, searchQueryOptions);

    const list = searchQueryData?.topicPlayList ? searchQueryData.topicPlayList.mediaPlayback : [];
    const hasMore = searchQueryData?.topicPlayList ? searchQueryData.topicPlayList.hasMore : false;

    return (
        <InningsComponent
            inningOptions={inningOptions}
            selectedInning={currentInning}
            setSelectedInning={setSelectedInning}
            gameLoading={gameLoading}
            searchQueryLoading={searchQueryLoading}
            loadingMore={loadingMore}
            hasMore={hasMore}
            list={list}
            fetchMoreData={fetchMoreData}
            searchQuery={searchQuery}
            gameError={gameError}
            searchQueryError={searchQueryError}
            skipSearchQuery={skipSearchQuery}
        />
    );

};

export default Innings;
